/**
 * @param {object} object to transform in a JSON string for React for "dangerouslySetInnerHTML"
 * @returns {object}
 * @private
 */
function objectToReactJsonString(object) {
  return { __html: JSON.stringify(object) };
}

const JsonUtil = {
  objectToReactJsonString
};

export default JsonUtil;
